import { Injectable } from "@angular/core";

export interface AuthConfig {
  skipAuthUrls: string[];
  apiBaseUrl: string;
  enableAuthForLocalAssets: boolean;
  redirectOnAuthError: boolean;
}

@Injectable({
  providedIn: "root",
})
export class AuthConfigService {
  private config: AuthConfig = {
    skipAuthUrls: [
      "/auth/",
      "/login",
      "/sign-up",
      "/forgot-password",
      "/trial",
      "/overview",
      "/docs",
      "/api/data/analyzer/explanations",
    ],
    apiBaseUrl: "",
    enableAuthForLocalAssets: false,
    redirectOnAuthError: true,
  };

  getConfig(): AuthConfig {
    return this.config;
  }

  updateConfig(newConfig: Partial<AuthConfig>): void {
    this.config = { ...this.config, ...newConfig };
  }

  shouldSkipAuth(url: string): boolean {
    const matched = this.config.skipAuthUrls.find((skipUrl) =>
      url.includes(skipUrl),
    );
    if (matched) {
      console.log(`🔍 URL "${url}" matched skip pattern: "${matched}"`);
    }
    return this.config.skipAuthUrls.some((skipUrl) => url.includes(skipUrl));
  }

  shouldEnforceAuth(url: string): boolean {
    const skipAuth = this.shouldSkipAuth(url);
    console.log(`🔍 Auth check for ${url}: skipAuth=${skipAuth}`);

    if (skipAuth) {
      return false;
    }

    // Skip auth for local assets unless explicitly enabled
    if (!this.config.enableAuthForLocalAssets && url.includes("assets/")) {
      console.log(`🔍 Skipping auth for asset: ${url}`);
      return false;
    }

    console.log(`🔍 Auth will be enforced for: ${url}`);
    return true;
  }
}
